import React from "react";
import { calcResizableElementNewRect } from "../utils/functions";

export class ResizableElement extends React.Component {

    state = {
        cursorsActive: false
    }

  componentDidMount() {
    document.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const myDiv = this.parentWrapper;
    if (!myDiv?.contains(event.target)) {
      this.setState({
        cursorsActive: false
      })
    }
  }
    mouseDown = (e, direction) => {
        const rect = this.parentWrapper.getBoundingClientRect();
        e.persist()
        this.setState(
            {
                direction,
                prevClient: {
                    prevClientX: e?.clientX,
                    prevClientY: e?.clientY
                },
                initialPosition: {
                    x: rect.left,
                    y: rect.top,
                    width: rect.width,
                    height: rect.height,
                    top: rect.top,
                    left: rect.left,
                    right: rect.right
                },
                cursorsActive: true
            },
            () => {
                window.addEventListener(
                    "mousemove",
                    this.mouseMove
                );
                window.addEventListener("mouseup", this.mouseup);
            }
        )
    };
    mouseMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { height, position, width } = calcResizableElementNewRect(
            // this.props.language : pass the language to this part,
            "en",
            this.state.direction,
            { ...this.state.initialPosition },
            this.state.prevClient,
            e,
        );
        console.log('heqmove2whp', width, height, position);
        // if (width > 20 && height > 20) {

        this.parentWrapper.style.transform = `translate(${position.x}px, ${position.y}px)`;
        // this.parentWrapper.style.tranla = `${position.x - this.state.prevClientX}px`;
        // // this.parentWrapper.style.left = `${this.parentWrapper.style.left +10}px` ;
        // this.parentWrapper.style.top = `${position.y - this.state.prevClientY}px`;
        // this.parentWrapper.style.top = `${this.parentWrapper.style.top + 10}px`;
        //         // this.wrapperRef.style.transform = `translateY(${position.y}px)`
        this.parentWrapper.style.height = height + 'px'
        this.parentWrapper.style.width = width + 'px'
        // }
    };
    mouseup = () => {
        this.setState({
            cursorsActive: false
        }, () => {
            window.removeEventListener("mousemove", this.mouseMove);
            window.removeEventListener("mouseup", this.mouseup);
        })
    }
  onClick = (event) => {
    
    this.setState({
        cursorsActive: true
    }, () => {
        const selection = window.getSelection();
        selection.removeAllRanges();
        window.addEventListener("keydown", this.onKeyDown);
    })
  }
  onKeyDown = (e) => {
    const deleteKeys = ["Backspace", "Delete"]
    if(deleteKeys.includes(e.key)){
        this.parentWrapper.parentElement.parentElement.removeChild(this.parentWrapper.parentElement);
        window.removeEventListener("keydown", this.onKeyDown)
        console.log(e.key)
    }
}

    render() {
        const arrowsList = [
            { direction: 'nw', className: '', style: { top: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px`, left: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px` } },
            { direction: 'ne', className: '', style: { top: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px`, right: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px` } },
            { direction: 'sw', className: '', style: { bottom: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px`, left: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px` } },
            { direction: 'se', className: '', style: { bottom: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px`, right: this.props?.lang == 'en' ? `-${this.props.sideDistancePX}px` : `${this.props.sideDistancePX}px` } },
            { direction: 'top', className: '', style: {} },
            { direction: 'bottom', className: '', style: {} },
            { direction: 'left', className: '', style: {} },
            { direction: 'right', className: '', style: { right: this.props?.lang == 'en' ? '0' : '0' } },
        ]
        return (
            <div contentEditable={false} onClick={this.onClick} onKeyDown={this.onKeyDown} onInput = {this.onInput} ref={el => this.parentWrapper = el} style={{...this.props.parentWrapperStyle}}>
                <div ref={el => this.wrapperRef = el} style={{ position: "relative", width: "100%", height: "100%", background: "red" }}>
                    {this.props.children}
                    {arrowsList?.map((arr, index) => {
                        const { direction, style, className } = arr;
                        return (
                            <div
                                key={index}
                                className={`${this.props?.sharedClassName} ${direction} ${className} ${this.state.cursorsActive ? this.props.activeClassName : ''}`}
                                onMouseDown={(e) =>
                                    this.mouseDown(e, direction)
                                }
                                style={Object.assign(style, this.props?.sharedStyles)}
                            ></div>
                        );
                    })}
                </div>
            </div>
        );
    }
}